import { Card, Col, Container, Row } from "react-bootstrap";
import Navigation from "../components/navbar";
import Cat from "../photos/cat.jpg";
import Cherry from "../photos/cherry.JPG";
import Bag from "../photos/beadedbag.jpeg";
import Scrunchie from "../photos/scrunchie.jpeg";
import Bow from "../photos/bownecklace.jpeg";

export default function Tries() {
  return (
    <>
      <Navigation />
      <Container>
        <br></br>
        <br></br>
        <br></br>
        <Row>
          <Col>
            {" "}
            <h1 class="display-2 text-left" style={{ textAlign: "right" }}>
              thuyvy tries things!
            </h1>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card>
              <Card.Img src={Scrunchie} />
              <Card.Body>
                <Card.Title>Flower Scrunchies!</Card.Title>
                <Card.Subtitle>feat Adrienne</Card.Subtitle>

                <Card.Link href="https://www.youtube.com/watch?v=XI6STvzwTkA">
                  tutorial
                </Card.Link>
              </Card.Body>
            </Card>
          </Col>
          <Col>
            <Card>
              <Card.Img src={Bag} />
              <Card.Body>
                <Card.Title>Beaded Bag!</Card.Title>

                <Card.Link href="https://collectivegen.com/2024/01/how-to-make-a-beaded-handbag/">
                  tutorial
                </Card.Link>
              </Card.Body>
            </Card>
          </Col>
          <Col>
            <Card>
              <Card.Img src={Cat} />
              <Card.Body>
                <Card.Title>Cat Beanie!</Card.Title>
                <Card.Subtitle>feat Adrienne</Card.Subtitle>

                <Card.Link href="https://www.youtube.com/watch?v=ucLVhRLQjng">
                  tutorial
                </Card.Link>
              </Card.Body>
            </Card>
          </Col>
          <Col>
            <Card>
              <Card.Img src={Bow} />
              <Card.Body>
                <Card.Title>Beaded Bow Necklace</Card.Title>
                <Card.Link href="https://www.tiktok.com/@beadworld/video/7328479104703991071">
                  tutorial
                </Card.Link>
              </Card.Body>
            </Card>
          </Col>
          <Col>
            <Card>
              <Card.Img src={Cherry} />
              <Card.Body>
                <Card.Title>Cherry Bracelets!</Card.Title>
                <Card.Link href="https://honestlywtf.com/diy/diy-beaded-cherry-bracelet//">
                  tutorial
                </Card.Link>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
